import styled from 'styled-components';
import { ImageUrl } from "../../../utils/constants";

const CoachWrapper = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
border-radius:6px;
.image-background{
    width:100%;
    display:flex;
    height: 272px
    border-radius: 6px 6px 0 0;
}
.details{
    width:100%;
    display:flex;
    
    background:white;
    border-radius: 0px 0px 6px 6px;
    padding: 0 40px 20px 40px;
}
`;

const ImageBackground = styled.div`
width:100%;
display:flex;

flex-wrap: wrap;
background-image: url(${ImageUrl}/${'event-section/coachDetailsBackground.png'});

background-position: center;
background-size: contain;
background-repeat: no-repeat;
.imageCard{
  width:320px;
  display:flex;
  margin: auto 20px auto auto;
  position: relative;
  top: 80px;
  .image{
    width:260px;
    height:260px;
    background:white;
    border-radius: 50%;
    padding: 4px;
    display:flex;
    margin: auto 0 auto auto;
    >img{
      width:100%;
      height:100%;
      border-radius: 50%;
    }
  }
}
.edu{
  width: calc(100% - 340px);
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: end;
  .name{
    color: #FFFFFF;
    font-family: Lato;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px;
    align-self: stretch;
    width:100%;
    padding-bottom: 12px;
  }
  .education {
    color: #FFFFFF;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    width: 100%;
    padding-bottom: 20px;
  }
}
`;

const CoachDetailCard = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
.categoryWrapper{
  padding-left:300px;
  display:flex;
  width: 100%;
  margin: 20px 0 40px 0;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px;

  .category{
    display:flex;
    height: 40px;
    background: #6A73C1;
    border-radius: 40px;
    border: 1px solid  #EFEFEF;
    justify-content:center;
    align-items: center;
    color: #EFEFEF
    text-align: center;
    font-family: Lato;
    gap: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    // margin-right: 12px;
    // margin-bottom: 12px;
    padding: 8px 16px;
    text-transform: capitalize;
  }
}
.bio{
  color:  #184A61;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  width: 1200px;
}

`;



export { CoachWrapper, ImageBackground, CoachDetailCard };